import EnableNewPatientsModal from "./EnableNewPatientsModal.js";
export default EnableNewPatientsModal;
